<template>
	<section>
		<div class="flex flex-center" style="padding-top: 76px">
			<div>
				<div class="text-center"><img src="../assets/nodata.png"></div>
					<div class="page-text" style="width:100%">还没有可以编辑的内容组件</div>
				</div>
			</div>
	</section>
</template>
<style type="text/css" scoped="">
.page-text {
	font-size: 16px;
	color: #324057;
	text-align: center;
	padding: 30px 0px;
}

</style>
<script type="text/javascript">
export default {
	props: []
}

</script>



// WEBPACK FOOTER //
// noData.vue?410531cf